module.exports = __webpack_public_path__ + "static/img/kdSimulator_1.e77cff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdSimulator/kdSimulator_1.jpg
// module id = 9zyW
// module chunks = 1